import {
  AccordionPanel,
  useAccordionContext,
  useAccordionItemContext,
} from '@reach/accordion';
import cx from 'clsx';
import React, { memo } from 'react';

import styles from '@/components/SideNavigation/MainNavigation/MainNavigation.module.scss';
import { isEqual } from '@/utils/lodash-alternatives';

interface AnimatedAccordionPanelProps {
  children: React.ReactNode;
}

const AnimatedAccordionPanel: React.FC<AnimatedAccordionPanelProps> = memo(
  ({ children }) => {
    const { isExpanded } = useAccordionItemContext();
    const { openPanels } = useAccordionContext();
    const loadingAnimation = isExpanded && openPanels.length > 0;

    return (
      <AccordionPanel
        hidden={false}
        aria-hidden={!isExpanded || undefined}
        className={cx(
          'accordion-panel',
          styles.accordionPanel,
          loadingAnimation ? styles.showPanel : styles.hidePanel
        )}
      >
        {children}
      </AccordionPanel>
    );
  },
  (
    prevProps: AnimatedAccordionPanelProps,
    nextProps: AnimatedAccordionPanelProps
  ) => isEqual(prevProps, nextProps)
);

export default AnimatedAccordionPanel;
